import React from 'react';
import styles from './NavItem.module.css';
import { Tooltip as ArrowedTooltip } from '@/components/ArrowedTooltip/Tooltip';
import { NavItemOption } from '../Sidebar';
import Tooltip from '@/components/Tooltip';

const NavItem = ({ 
  logo, 
  label, 
  dropdownOptions = [] as NavItemOption[],
  currentLocation,
  isOpen = false,             // Is the dropdown open
  // Handler
  onClick,                    // Handler for clicking the main nav item
  onToggleDropdown,           // not sure if needed Handler for toggling dropdown open/closed
  onOptionClick,              // Handler for clicking a dropdown option when you click on it
  isCollapsed = false,
  href,
  isMainTabActive = false,
}) => {
  // const [_, navigate] = useLocation(); // Use the location hook for navigation
  const hasActiveChild = dropdownOptions.some(option => option.href === currentLocation);
  const isActive = !hasActiveChild && isMainTabActive;
  
  const renderTooltipContent = () => {
    if (dropdownOptions.length === 0) {
      return null;
    }
    
    return (
      <div className={styles.tooltipContent}>
        {dropdownOptions.map((option, index) => (
          <div 
            key={index}
            className={`${styles.tooltipItem} ${option.href === currentLocation ? styles.active : ''}`}
            onClick={e => onOptionClick(option.href, e)}
          >
            {option.label}
          </div>
        ))}
      </div>
    );
  };
  
  // Collapsed view with tooltip for dropdown options
  if (isCollapsed) {
    return (
      <div className={styles.navItemContainerCollapsed}>
        {dropdownOptions && dropdownOptions.length > 0 ? (
          <ArrowedTooltip 
            title={renderTooltipContent()} 
            placement="right"
          >
            <button 
              className={`${styles.logoButton} ${isActive? styles.childActive : ''}`}
              onClick={e => onClick(href, e)}
            >
              {logo && (
                <span className={`${styles.logoCollapsed} ${(isActive || hasActiveChild) ? styles.logoActive : ''}`}>
                  {logo}
                </span>
              )}
            </button>
          </ArrowedTooltip>
        ) : (
          <button 
            className={`${styles.logoButton} ${isActive? styles.active : ''}`}
            onClick={e => onClick(href, e)}
          >
            {logo && (
              <span className={`${styles.logoCollapsed} ${(isActive || hasActiveChild) ? styles.logoActive : ''}`}>
                {logo}
              </span>
            )}
          </button>
        )}
        
        <div className={styles.labelCollapsed}>
          {label}
        </div>
      </div>
    );
  }
  
  // Expanded view (normal)
  return (
    <div className={styles.navItemContainer}>
      <button 
        className={`${styles.navItem} ${isActive ? styles.active : ''}`}
        onClick={e => onClick(href, e)}
      >
        {logo && (
          <span className={`${styles.logo} ${(isActive || hasActiveChild) ? styles.logoActive : ''}`}>
            {logo}
          </span>
        )}
        
        <span className={styles.label}>{label}</span>
        
        {dropdownOptions.length > 0 && ( 
          <span className={`${styles.arrow} ${isOpen ? styles.arrowUp : ''}`}>
            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.99995 6.975C6.13328 6.975 6.26228 6.95 6.38695 6.9C6.51228 6.85 6.61662 6.78334 6.69995 6.7L11.3 2.1C11.4833 1.91667 11.575 1.68334 11.575 1.4C11.575 1.11667 11.4833 0.883336 11.3 0.700003C11.1166 0.516669 10.8833 0.425003 10.6 0.425003C10.3166 0.425003 10.0833 0.516669 9.89995 0.700003L5.99995 4.6L2.09995 0.700003C1.91662 0.516669 1.68328 0.425003 1.39995 0.425003C1.11662 0.425003 0.883286 0.516669 0.699952 0.700003C0.516619 0.883336 0.424951 1.11667 0.424951 1.4C0.424951 1.68334 0.516619 1.91667 0.699952 2.1L5.29995 6.7C5.39995 6.8 5.50828 6.87067 5.62495 6.912C5.74162 6.954 5.86662 6.975 5.99995 6.975Z" fill="currentColor"/>
            </svg>
          </span>
        )}
      </button>
      
      {dropdownOptions.length > 0 && isOpen && ( 
        <div className={styles.dropdown}>
          {dropdownOptions.map((option, index) => (
            <Tooltip
              key={index}
              title={option.disabledTooltip ?? ""}
              placement="right"
            >
              <button
                disabled={option.disabled}
                className={`${styles.dropdownItem} ${option.href === currentLocation ? styles.childActive : ''}`}
                onClick={e => onOptionClick(option.href, e)}
              >
                {option.label}
              </button>
            </Tooltip>
            
          ))}
        </div>
      )}
    </div>
  );
};

export default NavItem;